import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function FooterLink({ to, label, isExternal = false, isPlaceholder = false }) {
  const handleClick = (e) => {
    if (isPlaceholder) {
      e.preventDefault();
      toast.info(`${label} page is coming soon!`, {
        description: "We are currently designing and building this section.",
        id: `placeholder-${label.toLowerCase().replace(/\s+/g, "-")}`,
      });
    }
  };

  const linkClass = "group flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#7C3AED] transition-colors duration-300 w-fit";
  const iconElement = (
    <ArrowRight className="w-3.5 h-3.5 opacity-0 -translate-x-1.5 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 text-[#7C3AED]" />
  );

  if (isPlaceholder) {
    return (
      <a href={to} onClick={handleClick} className={linkClass} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
        <span>{label}</span>
        {iconElement}
      </a>
    );
  }

  if (isExternal) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" className={linkClass} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
        <span>{label}</span>
        {iconElement}
      </a>
    );
  }

  if (to.startsWith("#") || to.includes("#")) {
    return (
      <a href={to} className={linkClass} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
        <span>{label}</span>
        {iconElement}
      </a>
    );
  }

  return (
    <Link to={to} className={linkClass} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <span>{label}</span>
      {iconElement}
    </Link>
  );
}
